export default __webpack_public_path__ + "static/media/collisions.0e2eb1de.jpg";